import { combineReducers } from 'redux';
import { withEntityPermissions } from './components/withEntityPermissions';
import { preFetchEntityPermissions, useEntityPermissions } from './hooks/useEntityPermissions';
import { entitiesResource, reducer as entitiesReducer } from './modules/resources/entities';
const reducer = combineReducers({
  entities: entitiesReducer
});
export { entitiesReducer, entitiesResource, preFetchEntityPermissions, reducer, useEntityPermissions, withEntityPermissions };
export default reducer;